import { getIndexes } from "common/utils";
import { safeStr } from "common/api";

export function parseApplicationMetrics(result) {
  const [header, ...rows] = result.trim().split("\n");
  const headerIndexes = getIndexes(header);

  const _downlink = [];
  const _uplink = [];

  for (let row of rows) {
    const attrs = row.trim().split(/\s+/);
    const count = parseInt(attrs[headerIndexes["COUNTS"]]);

    if (count < 100) {
      continue;
    }

    const item = {
      app: attrs[headerIndexes["APP"]],
      min: parseFloat(attrs[headerIndexes["MIN-MBPS"]]),
      p10: parseFloat(attrs[headerIndexes["10%-MBPS"]]),
      p25: parseFloat(attrs[headerIndexes["25%-MBPS"]]),
      p50: parseFloat(attrs[headerIndexes["50%-MBPS"]]),
      p75: parseFloat(attrs[headerIndexes["75%-MBPS"]]),
      p90: parseFloat(attrs[headerIndexes["90%-MBPS"]]),
      max: parseFloat(attrs[headerIndexes["MAX-MBPS"]]),
    };

    const direction = attrs[headerIndexes["DIR"]];

    if (direction === "down") {
      _downlink.push(item);
    } else if (direction === "up") {
      _uplink.push(item);
    }
  }

  return {
    downlink: _downlink,
    uplink: _uplink,
  };
}

export function getApplicationMetricsMock(){
  return `APP                    DIR  MIN-MBPS  10%-MBPS 25%-MBPS 50%-MBPS 75%-MBPS 90%-MBPS MAX-MBPS  COUNTS    VOLUME
All-apps          down     0.234     5.235    6.453    8.498    9.568   12.567   30.456  145678 1886635353  
tcp:netflix       down     3.234     5.235    6.453    8.498    9.568   12.567   18.456   45678 886635353  
amazon            down     2.234     3.235    5.453   10.498   12.568   16.567   17.456   35678 786635353  
movistar+         down     7.234     8.235    9.453   11.498   14.568   17.567   20.456   33678 686635353  
youtube           down     4.234     8.235    9.453   14.498   16.568   19.567   22.456   23678 586635353  
tiktok            down     3.234     5.235    7.453    8.498    9.568   12.567   18.456   22678 486635353  
globo             down     9.234    10.235   11.453   18.498   20.568   25.567   30.456   20678 386635353  
tcp:speedtest.net down     1.234     3.235    4.453    5.498   12.568   13.567   19.456   18678 286635353  
tcp:microsoft     down     0.234     1.235    2.453    3.498    9.568   11.567   15.456   13678 186635353  
tcp:gmail.com     down     5.234     6.235    8.453    9.498   12.568   16.567   21.456   12678  96635353  
All-apps            up     0.234     5.235    6.453    8.498    9.568   12.567   30.456  145678 1886635353  
tcp:netflix         up     3.234     5.235    6.453    8.498    9.568   12.567   18.456   45678 886635353  
amazon              up     2.234     3.235    5.453   10.498   12.568   16.567   17.456   35678 786635353  
movistar+           up     7.234     8.235    9.453   11.498   14.568   17.567   20.456   33678 686635353  
youtube             up     4.234     8.235    9.453   14.498   16.568   19.567   22.456   23678 586635353  
tiktok              up     3.234     5.235    7.453    8.498    9.568   12.567   18.456   22678 486635353  
globo               up     9.234    10.235   11.453   18.498   20.568   25.567   30.456   20678 386635353  
tcp:speedtest.net   up     1.234     3.235    4.453    5.498   12.568   13.567   19.456   18678 286635353  
tcp:microsoft       up     0.234     1.235    2.453    3.498    9.568   11.567   15.456   13678 186635353  
tcp:gmail.com       up     5.234     6.235    8.453    9.498   12.568   16.567   21.456   12678  96635353`
}

export const parsePolicyNames = (response) => {
  const lines = response.trim().split("\n");
  const [_head, ...rows] = lines;
  const headerIndexes = getIndexes(_head);

  return Array.from(new Set(rows.map((row) => row.split(/\s+/)[headerIndexes["NAME"]])));
};

export const parseSubscriberGroupsNames = (response) => {
  const lines = response.trim().split("\n");
  const [_head, ...rows] = lines;
  const headerIndexes = getIndexes(_head);

  return Array.from(new Set(rows.map((row) => row.split(/\s+/)[headerIndexes["SUBSCRIBER-GROUP"]])));
}

export function getPolicyFilterCmd(policiesRateSelected) {
  if (!policiesRateSelected || policiesRateSelected.length === 0) {
    return "all";
  } else {
    return `name '${policiesRateSelected
      .map((policy) => `"${policy.replaceAll('"', '""')}"`)
      .join(",")}'`;
  }
}

export function getSubscriberGroupFilterCmd(subscriberGroupSelected) {
  if (!subscriberGroupSelected || subscriberGroupSelected.length === 0) {
    return "all";
  } else {
    return `name '${subscriberGroupSelected
      .map((sub) =>`"${safeStr(sub).replaceAll('\'', '')}"`)
      .join(",")}'`;
  }
}

export function getSubscriberFilterCmd(subscriberSelected) {
  if (!subscriberSelected) {
    return "all";
  } else {
    const { addr, subsId } = subscriberSelected;
    return addr ? addr : `id ${subsId}`;
  }
}

export function getCategoryFilterCmd(category) {
  if (category === "All-apps" || category === "Global") {
    return "all";
  } else {  
    return `name "${safeStr(category).replaceAll('\'', '')}"`;
  }
}

export function getApplicationMetricsTimeMock(){
  return `TIME D-MIN-MBPS D-10%-MBPS D-25%-MBPS D-50%-MBPS D-75%-MBPS D-90%-MBPS D-MAX-MBPS   D-COUNTS   D-VOLUME U-MIN-MBPS U-10%-MBPS U-25%-MBPS U-50%-MBPS U-75%-MBPS U-90%-MBPS U-MAX-MBPS   U-COUNTS   U-VOLUME
2025-11-06T02:00:00      0.866      1.338      3.648      6.893     24.251     72.454     83.686         16  141372143      0.366      0.380      0.553      1.942      3.062     45.572     62.672          8     254866
2025-11-06T03:00:00      1.322      1.945      2.671      5.395      7.927     13.882     31.736         18    1798341      0.887      0.887      1.077      1.077     60.585     60.585     60.585          3     121785
2025-11-06T04:00:00      0.898      3.167      4.116      6.094     11.138     13.622     24.158         22    1654795      0.923      0.923      0.923     41.483     41.483     41.483     41.483          2     117023
2025-11-06T05:00:00      1.018      1.960      2.613      3.636      8.347     22.587     66.408         17    1748937      0.977      0.977      0.977      1.039      1.039      1.039      1.039          2      41934
2025-11-06T06:00:00      0.589      3.486      4.808      6.943      9.088     10.202     11.585         16    1427179      0.993      0.993      1.421     28.655     45.163     62.248     62.248          5     214883
2025-11-06T07:00:00      1.344      3.504      4.436     23.033     26.486     27.522     47.182         26    1764788      1.174      1.174      1.899      1.899     46.886     46.886     46.886          3     119164
2025-11-06T08:00:00      1.427      1.726      3.137      4.157      6.265      6.370     29.202         11     654748      0.999      0.999      0.999      1.232      1.232      1.232      1.232          2      42196
2025-11-06T09:00:00      1.279      3.551      5.515     15.361     32.663     44.994     83.696         85  116056509      0.017      1.024      3.849     38.635     84.958     90.747     91.909        226   67850831
2025-11-06T10:00:00      1.622      4.858      9.134     25.525     40.656     48.166     77.901        149   12282874      0.459      0.852     19.053     55.385     69.483     90.041     91.557        349   74886541
2025-11-06T11:00:00      0.033      1.082      2.199      4.230      9.879     25.924     62.340        133  176315657      0.313      0.758      0.895     17.500     19.316     23.495     74.528         60   43669755
2025-11-06T12:00:00      0.610      2.597      4.133      8.649     22.096     41.798     89.433        159   12788829      0.425      0.510      0.735      0.851      1.013      2.984     24.565         56    1418077
2025-11-06T13:00:00      0.440      1.535      2.881     16.892     30.181     41.958     81.738        419   42291397      0.580      0.930      0.930      0.932      0.934      1.305     53.092       1159   38268836
2025-11-06T14:00:00      1.013      2.619      5.161      8.849     20.477     27.209     47.264         78    6227045      0.551      0.572      0.938      9.319     19.774     21.764     54.843         11     320099
2025-11-06T15:00:00      0.534      2.325      4.246      6.559     15.093     37.758     68.233         65    4351206      0.573      0.705      0.790      1.037     10.766     25.765     27.491         16     516831
2025-11-06T16:00:00      1.169      2.959      4.482      6.136     18.212     30.793     50.148         70    4473783      0.429      0.590      0.698      0.865      0.965     11.625     39.849         36     652207
2025-11-06T17:00:00      1.546      2.784      4.789      7.425     19.482     31.381     88.108        127    8702515      0.517      0.652      0.824      0.998     30.395     63.389     69.138         80    2770602
2025-11-06T18:00:00      0.396      0.790      1.696      7.938     32.533     43.939     85.851        128   27357525      0.626      0.657      0.680      2.357     23.653     28.962     54.020         10     236948
2025-11-06T19:00:00      0.484      2.502      4.499      6.571     20.841     29.597     92.111        250   44297750      0.569      0.718      0.784      1.193     21.662     31.504     52.755         21     676079
2025-11-06T20:00:00      0.376      0.794      1.698      3.729      6.720     19.303     47.457        119   12703902      0.375      0.669      0.750      0.816      0.936      1.062     52.879         52    1142801
2025-11-06T21:00:00      1.961      3.423      4.960      8.507     47.358     85.866     93.441         67  211583422      0.635      0.708      0.786      0.885      2.209     14.628     53.841         33    1159947
2025-11-06T22:00:00      0.553      3.417      4.383      5.984      9.403     18.770     51.094         29    1618586      0.763      0.811      1.031     10.867     18.576     22.231     55.856         12     278478
2025-11-06T23:00:00      1.327      3.247      5.760      6.590     11.204     16.037     42.468         28    1841532      0.449      0.701      0.734      0.961     24.588     25.470     56.526         10     235344
2025-11-07T00:00:00      1.326      2.658      3.877      6.370     25.831     27.637     32.176         46    1774647      0.348      0.764      0.822      0.991     11.657     28.048     36.819         16     340598
2025-11-07T01:00:00      0.514      2.781      4.483      9.364     27.599     44.382     55.011        139    8594478      0.386      0.560      0.662      0.795      0.924      2.233     32.293         44    1027510
2025-11-07T02:00:00      1.921      1.921      3.329      4.101      4.101      4.240      4.240          4     135653      0.564      0.744      0.744      0.870      0.924      9.824      9.824          6      95486`
}

const parseDate = d3.timeParse("%Y-%m-%dT%H:%M:%S");

export function parseTimeEvolution(response){
  const [header, ...rows] = response.trim().split("\n");
  const headerIndexes = getIndexes(header);
  const parsedDate = rows.reduce((acc, row) => {  
    const attrs = row.trim().split(/\s+/);
    const itemDownlink ={
      
      time: new Date(parseDate(attrs[headerIndexes["TIME"]])),
      min: parseFloat(attrs[headerIndexes["D-MIN-MBPS"]]),
      p10: parseFloat(attrs[headerIndexes["D-10%-MBPS"]]),
      p25: parseFloat(attrs[headerIndexes["D-25%-MBPS"]]),
      p50: parseFloat(attrs[headerIndexes["D-50%-MBPS"]]),  
      p75: parseFloat(attrs[headerIndexes["D-75%-MBPS"]]),
      p90: parseFloat(attrs[headerIndexes["D-90%-MBPS"]]),
      max: parseFloat(attrs[headerIndexes["D-MAX-MBPS"]]),
    }
    const itemUplink ={
      time: new Date(parseDate(attrs[headerIndexes["TIME"]])),
      min: parseFloat(attrs[headerIndexes["U-MIN-MBPS"]]),
      p10: parseFloat(attrs[headerIndexes["U-10%-MBPS"]]),
      p25: parseFloat(attrs[headerIndexes["U-25%-MBPS"]]),
      p50: parseFloat(attrs[headerIndexes["U-50%-MBPS"]]),  
      p75: parseFloat(attrs[headerIndexes["U-75%-MBPS"]]),
      p90: parseFloat(attrs[headerIndexes["U-90%-MBPS"]]),
      max: parseFloat(attrs[headerIndexes["U-MAX-MBPS"]]),
    }
    acc.downlink.push(itemDownlink);
    acc.uplink.push(itemUplink);
    return acc;
  }, {downlink: [], uplink: []});
  return parsedDate;
}